import i18n from "@/i18n";

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "https://baelleaves.com/backend";
export const API_BASE_URL = `${BACKEND_URL}/api.php`;

export async function fetchAPI(endpoint: string, init?: RequestInit) {
  try {
    const currentLang = i18n.language || "en";
    // Check if the query has parameters already
    const connector = endpoint.includes("?") ? "&" : "?";
    // Append the lang param unless already explicitly set, or if we are in the admin panel
    const isAdminRoute = typeof window !== "undefined" && window.location.pathname.includes("/admin-panel");
    const url = endpoint.includes("lang=") || endpoint.includes("type=setup") || endpoint.includes("type=login") || isAdminRoute
      ? `${API_BASE_URL}${endpoint}`
      : `${API_BASE_URL}${endpoint}${connector}lang=${currentLang}`;

    const response = await fetch(url, init);
    return response.json();
  } catch (error) {
    console.error("Fetch failed:", error);
    throw error;
  }
}

export async function getSettings() {
  return fetchAPI("?type=settings");
}
